import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export default defineStore('config', () => {
  const config = ref<ImportMetaEnv>({});

  const getConfig = async () => {
    const targetScript = Array.from(document.scripts).find(
      (script) => script.type == 'module' && script.src.includes('index.js')
    );
    if (!targetScript) {
      throw new Error('index.js script not found');
    }
    const scriptUrl = new URL(targetScript.src);
    const basePath = scriptUrl.href.substring(0, scriptUrl.href.lastIndexOf('/') + 1);
    const configUrl = `${basePath}config.json`;

    const response = await fetch(configUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.status}`);
    }

    return response.json();
  };

  return {
    config,
    baseUrl: computed(() => config.value.NV_GATEWAY.replace('/api', '')),

    async init() {
      const configData = await getConfig();

      Object.keys(configData).forEach((key) => {
        if (key in import.meta.env) {
          import.meta.env[key] = configData[key];
        }
      });

      Object.assign(config.value, configData);
    }
  };
});
